import { Plugins } from '@leverege/plugin';

/* 
Detail:
  name : <string>, human readable name
  objectType : <string> the type of object which this can be used to invoke data
  placement : {
    sort : <string>
    group : [ <string> ],
  }
  create : function( ) // Returns a json representation for the detail model for this detail type

Details (lookup)
  What details supports type X // for selector
  */

function addToType(typeMap, type, detail) {
  const arr = typeMap.get(type);
  if (arr == null) {
    typeMap.set(type, [detail]);
  } else {
    arr.push(detail);
  }
}
function addDetails(details, {
  types: typeMap,
  lookup
}) {
  for (let n = 0; n < details.length; n++) {
    const detail = details[n];
    const {
      objectType,
      attrName
    } = detail;
    if (Array.isArray(objectType)) {
      objectType.forEach(type => {
        addToType(typeMap, type, detail);
        addToType(lookup, nameTypeKey(attrName, objectType), detail);
      });
    } else {
      addToType(typeMap, objectType, detail);
      addToType(lookup, nameTypeKey(attrName, objectType), detail);
    }
  }
}
function nameTypeKey(name, objectType) {
  return `${name}:${objectType}`;
}

/**
 * Rebuilds the lookup for the associations
 */
function processor(details) {
  const types = new Map(); // name:type -> detail lookup
  const lookup = new Map();
  addDetails(details, {
    types,
    lookup
  });

  // Add any details available from a a creator
  const creators = Plugins.get('DetailCreator');
  creators.forEach(creator => {
    const details = creator.create();
    addDetails(details, {
      types,
      lookup
    });
  });

  // Add any * details to all types
  const all = types.get('*') || [];
  if (all.length > 0) {
    types.forEach((arr, type) => {
      if (type !== '*') {
        arr.push(...all);
      }
    });
  }
  return {
    types,
    lookup
  };
}
const view = Plugins.createView('Detail', {
  processor
});

/**
 * Returns an Array of Details that can be used
 * for the given type of object
 */
function getDetailsFor(type) {
  const {
    types
  } = view.get();
  return types.get(type) || [];
}
function getDetail(name, objectType) {
  const {
    lookup
  } = view.get();
  const key = nameTypeKey(name, objectType);
  const details = lookup.get(key);
  if (details) {
    return details[0];
  }
  return null;
}

// Detail creators
// These will contribute details to the available details
// based on some other mechanism, like a conversion of
// attributes to details.

// Allow creators to dirty the pool of available details
// so the pool is recalculated
const dirty = () => {
  view.dirty = true;
};
Plugins.get('DetailCreator').forEach(dc => {
  dc.onChange(dirty);
});
Plugins.on('DetailCreator', evt => {
  const add = evt.type === Plugins.PLUGIN_ADDED;
  evt.plugin.onChange(add ? dirty : null);
});
export default {
  getDetailsFor,
  getDetail
};